import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import NormalHeader from '../components/NormalHeader';
import NormalFooter from '../components/NormalFooter';
import { useNormalReservation } from '../context/NormalReservationContext';

const NormalThanks: React.FC = () => {
  const navigate = useNavigate();
  const { reservationNumber, resetForm } = useNormalReservation();

  useEffect(() => {
    if (!reservationNumber) {
      navigate('/form/normal/form1');
    }
  }, [reservationNumber, navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-gray-50">
      <NormalHeader />
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-10 sm:px-6">
        <div className="rounded-2xl bg-white p-8 text-center shadow-sm ring-1 ring-gray-100">
          <p className="text-sm font-semibold text-brand-primary">Step 4</p>
          <h1 className="mt-2 text-2xl font-bold text-gray-900">予約が完了しました</h1>
          <p className="mt-3 text-sm text-gray-600">ご予約ありがとうございます。以下が予約番号です。</p>
          <div className="mt-5 inline-flex items-center gap-2 rounded-lg bg-gray-50 px-4 py-3 text-lg font-mono font-semibold text-gray-900 ring-1 ring-gray-200">
            {reservationNumber || '発行中'}
          </div>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <button
              onClick={() => {
                resetForm();
                navigate('/form/normal/form1');
              }}
              className="rounded-lg bg-brand-primary px-4 py-2 text-sm font-semibold text-white shadow hover:bg-green-600"
            >
              もう一度予約する
            </button>
            <button
              onClick={() => navigate('/form/normal/reservations')}
              className="rounded-lg border border-gray-200 px-4 py-2 text-sm font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50"
            >
              予約一覧を見る
            </button>
          </div>
        </div>
      </main>
      <NormalFooter />
    </div>
  );
};

export default NormalThanks;
